import React from 'react'; // Removed useContext, useEffect, useState
import { useSelector } from 'react-redux'; // 1. Redux hook
import { List } from 'antd';
import moment from 'moment';

export default function Availability() {
  // 2. Select strictly what we need
  const date = useSelector(state => state.date);
  const inspectorAvailability = useSelector(state => state.inspectorAvailability);

  // 3. Fallback logic
  // If inspectorAvailability is null/undefined from store, default to {}
  const selectedAvailability = inspectorAvailability || {};
  
  const current = date ? date : new Date();

  // Note: I removed the useEffect/useState that was here.
  // There is no need to copy props into state; just use the Redux value directly.

  return (
    <div>
      {selectedAvailability.availability && selectedAvailability.availability.length > 0 && (
        <List
          dataSource={selectedAvailability.availability}
          renderItem={(availability) => {
            const { date: start, end } = availability;
            
            // Convert to JS dates for comparison
            if (start.toDate() > current || current > end.toDate()) return <div></div>;

            const [b, e] = [moment(start.toDate()), moment(end.toDate())];
            
            return (
              <div>
                Available {b.format('hh:mm A')} - {e.format('hh:mm A')}
              </div>
            );
          }}
        />
      )}
    </div>
  );
}